export const DOMAIN = 'dataStore.classifications';
